document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const submitButton = productForm.querySelector('button[type="submit"]');
  if (!submitButton) return;

  const variantRadios = document.querySelector('variant-radios');
  if (!variantRadios) return;

  // Leggi il lead time dalla variabile globale
    const leadTime = window.productLeadTime || 7;

  console.log('Lead time caricato:', leadTime);

  function getSelectedVariant() {
    const selectedInput = variantRadios.querySelector('input[type="radio"]:checked');
    if (!selectedInput) return null;

    const selectedValue = selectedInput.value;
    const variantsData = variantRadios.querySelector('[data-all-variants-no-high]');
    if (!variantsData) return null;

    const variants = JSON.parse(variantsData.textContent);
    return variants.find(v => v.option1 === selectedValue || v.title === selectedValue);
  }

  function updateButtonText() {
    const variant = getSelectedVariant();
    if (!variant) return;

    const buttonSpan = submitButton.querySelector('span');
    if (!buttonSpan) return;

    const baseText = 'Aggiungi al carrello';
    let deliveryText = '';

    console.log('Variante:', variant.title);
    console.log('Inventory quantity:', variant.inventory_quantity);
    console.log('Inventory policy:', variant.inventory_policy);
    console.log('Lead time usato:', leadTime);

    if (variant.available) {
      if (typeof variant.inventory_quantity !== 'undefined') {
                if (variant.inventory_quantity > 0) {
          deliveryText = ' – consegna in 24/48h';
        } else if (variant.inventory_policy === 'continue') {
          deliveryText = ' – consegna in ' + leadTime + ' giorni';
        }
      } else {
        deliveryText = ' – consegna in 24/48h';
      }
    }

    buttonSpan.textContent = baseText + deliveryText;
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const buttonSpan = submitButton.querySelector('span');
        if (buttonSpan && buttonSpan.textContent === 'Aggiungi al carrello') {
          setTimeout(updateButtonText, 50);
        }
      }
    });
  });

  observer.observe(submitButton, {
    childList: true,
    subtree: true,
    characterData: true
  });

  variantRadios.addEventListener('change', function(event) {
    if (event.target.type === 'radio') {
      setTimeout(updateButtonText, 150);
    }
  });

  updateButtonText();
});
